// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-bar';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm15 15.5V19H3v-3.5h12Zm5-6V13H3V9.5h17Zm-10-6V7H3V3.5h7Z' />
);

export const viewBox = '0 0 22 22';
